import { get, post } from '../tools/http';
import { getCachedValue, setCachedValue } from '../tools/cache';

const LOCALSTORAGE_KEY_CONTACTS = 'page-contacts';
const LOCALSTORAGE_TTL = 300;

export default {
    state: {
        contacts: {},
        docLinks: {},
    },
    mutations: {
        setContacts: (state, contacts) => state.contacts = contacts,
        setDocLinks: (state, docLinks) => (state.docLinks = docLinks),
    },
    actions: {
        getContacts: async ctx => {
            let contacts = getCachedValue(LOCALSTORAGE_KEY_CONTACTS);

            if (contacts === null) {
                contacts = await get('cms', 'entity/select/page?name=contacts');
                setCachedValue(LOCALSTORAGE_KEY_CONTACTS, contacts, LOCALSTORAGE_TTL);
            }

            const docLinks = {};
            for (const doc of contacts.list[0].data.docs) {
                if (doc.type) {
                    docLinks[doc.type] = doc;
                }
            }

            ctx.commit('setContacts', contacts.list[0].data);
            ctx.commit('setDocLinks', docLinks);
        },
        subscribeToNews: async (ctx) => {
            await post('profile', 'subscribe', {type: 'news'}, true);
        },
    },
    getters: {
        contacts: state => state.contacts,
        docLinks: state => state.docLinks,
    },
};
